import { useState } from "react";

export function useSystemSelectorHook() {
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    return { showAddDialog, setShowAddDialog, searchValue, setSearchValue };
}
